// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-button-container {
    width: 85%;
    position: fixed;
    bottom: 0;
    z-index: 10;
    background-color: #fff;
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    transition: 0.2s ease-in-out;
    justify-content: space-between;
    height: 80px;
}

.selected-count-container {
    margin-left: 20px;
    font-size: 18px;
}

.buttons-control-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 20px;
}

.delete-button-container-mobile {
    position: fixed;
    bottom: 0;
    z-index: 10;
    background-color: #fff;
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    transition: 0.2s ease-in-out;
    justify-content: space-between;
    height: 60px;
    width: 100%;
}

@media screen and (max-width: 1300px) {
    .delete-button-container {
        width: 90%;
    }
}

    /*for Mobile Devices*/
@media screen and (max-width: 600px) {
    .selected-count-container {
        margin-left: 10px;
        font-size: 14px;
    }
}

@media print {
    .delete-button-container, .delete-button-container-mobile {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/shared/css/bottom-alert.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,eAAe;IACf,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,8BAA8B;IAC9B,YAAY;IACZ,WAAW;AACf;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;IAEI,qBAAqB;AACzB;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".delete-button-container {\n    width: 85%;\n    position: fixed;\n    bottom: 0;\n    z-index: 10;\n    background-color: #fff;\n    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.25);\n    display: flex;\n    align-items: center;\n    transition: 0.2s ease-in-out;\n    justify-content: space-between;\n    height: 80px;\n}\n\n.selected-count-container {\n    margin-left: 20px;\n    font-size: 18px;\n}\n\n.buttons-control-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-right: 20px;\n}\n\n.delete-button-container-mobile {\n    position: fixed;\n    bottom: 0;\n    z-index: 10;\n    background-color: #fff;\n    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.25);\n    display: flex;\n    align-items: center;\n    transition: 0.2s ease-in-out;\n    justify-content: space-between;\n    height: 60px;\n    width: 100%;\n}\n\n@media screen and (max-width: 1300px) {\n    .delete-button-container {\n        width: 90%;\n    }\n}\n\n    /*for Mobile Devices*/\n@media screen and (max-width: 600px) {\n    .selected-count-container {\n        margin-left: 10px;\n        font-size: 14px;\n    }\n}\n\n@media print {\n    .delete-button-container, .delete-button-container-mobile {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
